exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nutrition-settings__group{margin-top:18px}.nutrition-settings__group-label{font-family:\"Bebas Neue\",\"bebas-fallback\",\"Helvetica Neue\",\"Helvetica\",\"Arial\",sans-serif;font-size:16px;font-size:1rem;margin-bottom:8px}.nutrition-settings__options{max-width:600px}.nutrition-settings__row{display:flex;flex-wrap:wrap;margin-bottom:-8px}.nutrition-settings__row+.nutrition-settings__row{margin-top:8px}.nutrition-settings__button{background-color:transparent;border:1px solid #bfbfbf;border-radius:4px;color:inherit;cursor:pointer;font-size:14.864px;font-size:0.929rem;margin:0 8px 8px 0;padding:6px 12px;transition:background-color 0.3s ease, color 0.3s ease}.nutrition-settings__button.active{background-color:#fa6422;border-color:#fa6422;color:#ffffff}\n", ""]);

// exports
exports.locals = {
	"nutrition-settings__group": "nutrition-settings__group",
	"nutrition-settings__group-label": "nutrition-settings__group-label",
	"nutrition-settings__options": "nutrition-settings__options",
	"nutrition-settings__row": "nutrition-settings__row",
	"nutrition-settings__button": "nutrition-settings__button",
	"active": "active"
};